import { render } from "./QuantyDonutChart.vue?vue&type=template&id=2b94e496&scoped=true"
import script from "./QuantyDonutChart.vue?vue&type=script&lang=js"
export * from "./QuantyDonutChart.vue?vue&type=script&lang=js"

import "./QuantyDonutChart.vue?vue&type=style&index=0&id=2b94e496&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b94e496"]])

export default __exports__